module.exports = __webpack_public_path__ + "static/media/CRUSH.b7630d11.svg";